import request from '@/utils/request'

const getQrcode = bankCode => {
  return request({
    url: `/api/qrcode/${bankCode}`,
    method: 'get'
  })
}

const createQrcode = (bankCode, data) => {
  return request({
    url: `/api/qrcode/${bankCode}`,
    method: 'post',
    data
  })
}

const clearQrcode = id => {
  return request({
    url: `/api/qrcode/${id}`,
    method: 'delete'
  })
}

export default {
  getQrcode,
  createQrcode,
  clearQrcode
}
